import BaseProxy from './Proxy';

export default class RechargeTransactionsProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/searchRechargeTransactions', parameters);
  }

  timeFrame() {
    return this.submit('get', `${this.endpoint}/timeFrame`);
  }
}
